import React, { createContext, useContext, useMemo, useState } from "react";
import { getStoredUser, persistUser, clearStoredUser } from "../services/authService";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => getStoredUser());

  const value = useMemo(
    () => ({
      user,
      isAuthenticated: Boolean(user),
      isAdmin: user?.role === "Admin",
      loginUser: (nextUser) => {
        persistUser(nextUser);
        setUser(nextUser);
      },
      logout: () => {
        clearStoredUser();
        setUser(null);
      },
      updateUser: (nextUser) => {
        persistUser(nextUser);
        setUser(nextUser);
      },
    }),
    [user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};
